// Pure structural tour data — TEXT is in /app/frontend/src/i18n/locales/*.json
// PRICES are in RON (base). Multi-currency handled via /app/frontend/src/i18n/pricing.js
// Use `useTour(slug)` from `useLocalizedTour.js` to get a language-aware tour object.

export const PICKUP_LOCATIONS = ["Oradea", "Băile Felix", "Băile 1 Mai"];

export const RIDER_LEVELS = ["incepator", "intermediar", "avansat"];

export const ORADEA_TOURS = [
  {
    slug: "sunset-panorama-ride",
    category: "oradea",
    price: 300,
    highlightsCount: 4,
    image: "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/680svx1o_WhatsApp%20Image%202026-05-13%20at%2023.18.06.jpeg",
    secondaryImage: "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/bjjgehz9_WhatsApp%20Image%202026-05-13%20at%2023.18.16%20%281%29.jpeg",
  },
  {
    slug: "northern-forest-escape",
    category: "oradea",
    price: 300,
    highlightsCount: 4,
    image: "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/z35fizo1_WhatsApp%20Image%202026-05-13%20at%2023.18.20.jpeg",
  },
  {
    slug: "lake-forest-explorer",
    category: "oradea",
    price: 300,
    highlightsCount: 4,
    image: "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/dj718is2_WhatsApp%20Image%202026-05-12%20at%2021.33.42.jpeg",
    secondaryImage: "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/28fiyzgq_WhatsApp%20Image%202026-05-12%20at%2021.33.44.jpeg",
  },
];

export const APUSENI_TOURS = [
  {
    slug: "apuseni-day-escape",
    category: "apuseni",
    price: 450,
    highlightsCount: 4,
    includesCount: 4,
    image: "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/npcrd1lw_WhatsApp%20Image%202026-04-28%20at%2000.04.27.jpeg",
  },
  {
    slug: "apuseni-weekend-escape",
    category: "apuseni",
    price: 2000,
    highlightsCount: 6,
    includesCount: 7,
    hasNonRiderNote: true,
    hasPricingNote: true,
    localExperiences: [
      { key: "local_stana", descField: "desc_weekend", pointsCount: 3, priceRON: 75, priceKey: "local-stana" },
    ],
    image: "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/ru1tpwz9_WhatsApp%20Image%202026-04-28%20at%2000.10.00.jpeg",
  },
  {
    slug: "transylvania-ebike-expedition",
    category: "apuseni",
    price: 5000,
    highlightsCount: 5,
    includesCount: 8,
    localExperiences: [
      { key: "local_stana", descField: "desc_expedition", pointsCount: 3, priceRON: 75, priceKey: "local-stana" },
      { key: "local_cultural", descField: "description", pointsCount: 3, priceOnRequest: true },
    ],
    image: "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/hv11lo7f_WhatsApp%20Image%202026-04-28%20at%2022.51.36.jpeg",
  },
];

export const ALL_TOURS = [...ORADEA_TOURS, ...APUSENI_TOURS];
export const getTourBySlug = (slug) => ALL_TOURS.find((t) => t.slug === slug);

export const RENTALS = [
  { key: "full_day",   priceKey: "rental-full-day",   priceRON: 300 },
  { key: "short_ride", priceKey: "rental-short-ride", priceRON: 180 },
];

export const GALLERY_IMAGES = [
  "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/36izoo0o_WhatsApp%20Image%202026-04-28%20at%2022.52.20%20%281%29.jpeg",
  "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/ariwobad_WhatsApp%20Image%202026-04-28%20at%2022.52.22%20%281%29.jpeg",
  "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/yxiy0p48_WhatsApp%20Image%202026-04-28%20at%2022.52.14.jpeg",
  "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/6wi8sctw_WhatsApp%20Image%202026-04-28%20at%2022.52.19.jpeg",
  "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/yjk879z7_WhatsApp%20Image%202026-04-28%20at%2022.52.23.jpeg",
];

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/usqox2hf_WhatsApp%20Image%202026-01-26%20at%2022.51.57.jpeg";
export const APUSENI_BG = "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/txh2x4q8_WhatsApp%20Image%202026-04-28%20at%2022.51.41.jpeg";
export const FEATURED_IMAGE = "https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/bjjgehz9_WhatsApp%20Image%202026-05-13%20at%2023.18.16%20%281%29.jpeg";
